import cn from "classnames";
import styles from "../styles/search.module.css";
import useRefCallback from "use-ref-callback";
import hotkey from "@atlas/tool/box/event/hotkey";
import React, { useEffect, useRef } from "react";
import { AppSettings } from "../lib/get-app-settings";
import Search from "./search";

export default function SearchModal(props: TSearchModalProps) {
  const { appSettings, baseUrl, opened, onClose } = props;

  useEffect(
    function disableBodyScroll() {
      document.body.style.overflow = opened ? "hidden" : "auto";
    },
    [opened]
  );

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(
    function autoFocusInput() {
      if (opened) inputRef.current?.focus();
    },
    [opened]
  );

  const handleKeyDown = useRefCallback<
    React.KeyboardEventHandler<HTMLDivElement>
  >((event) => {
    if (escapeHotkey.matches(event)) return onClose();
  });

  const handleClick = useRefCallback<React.MouseEventHandler<HTMLDivElement>>(
    (event) => event.target === event.currentTarget && onClose()
  );

  return (
    <div
      className={cn(styles.modalBackdrop, { [styles.opened]: opened })}
      onKeyDown={handleKeyDown}
      onClick={handleClick}
    >
      <Search
        className={styles.searchModal}
        appSettings={appSettings}
        baseUrl={baseUrl}
        inputRef={inputRef}
        onClose={onClose}
      />
    </div>
  );
}

type TSearchModalProps = {
  opened?: boolean;
  onClose: () => void;
  appSettings: AppSettings;
  baseUrl: string;
};

const escapeHotkey = hotkey("escape", "hidden");
